// extracted by mini-css-extract-plugin
export default {"popupInner":"AgeVerificationPopup__popupInner--1J8"};